/* eslint-disable import/order */
/* eslint-disable react/prop-types */
/* eslint-disable arrow-body-style */
import {
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from '@material-ui/core';
import { mdiClipboardArrowLeftOutline } from '@mdi/js';
import Icon from '@mdi/react';
import React, { useState } from 'react';
import AlertDialog from '../ConfirmationDialog';
import api from '../../service/api';
import { toast } from 'react-toastify';

const DuplicatedLeadsTable = ({ leads = [], mutate }) => {
  const [dialog, setDialog] = useState({
    msg: '',
    title: '',
  });
  const [leadToIndicate, setLeadToIndicate] = useState('');

  const [openDialog, setOpenDialog] = useState(false);

  const handleIndicateLead = (id, proposal) => {
    setLeadToIndicate('');

    setDialog({
      msg: `Tem certeza que deseja liberar manualmente a proposta: ${proposal}?`,
      title: 'Liberação de lead',
    });

    setLeadToIndicate(id);
    setOpenDialog(true);
  };

  const handleIndicateConfirm = async () => {
    if (!leadToIndicate) return;

    try {
      const resp = await api.put(`/lead-duplicates/release/${leadToIndicate}`);

      if (resp.data) {
        toast.success(resp.data?.message);
      }

      mutate();
    } catch (e) {
      toast.error(e?.response?.data?.message);
    }
  };

  return (
    <TableContainer component={Paper}>
      <AlertDialog
        open={openDialog}
        setOpen={setOpenDialog}
        msg={dialog.msg.length > 0 ? dialog.msg : 'Dialog'}
        title={dialog.title.length > 0 ? dialog.title : 'Dialog'}
        next={handleIndicateConfirm}
      />

      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell align="center">Proposta</TableCell>
            <TableCell>Nome do Cliente</TableCell>
            <TableCell>Veículo</TableCell>
            <TableCell>Concessionária</TableCell>
            <TableCell align="center">Liberado Por</TableCell>
            <TableCell align="center">Data da liberação</TableCell>
            <TableCell align="center">Data</TableCell>
            <TableCell align="center">Ações</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {leads?.map((lead) => (
            <TableRow key={lead.id}>
              <TableCell>{lead?.id}</TableCell>
              <TableCell align="center">{lead?.proposal}</TableCell>
              <TableCell>{lead?.client_name}</TableCell>
              <TableCell>{lead?.vehicle}</TableCell>
              <TableCell>{lead?.partner}</TableCell>
              <TableCell align="center">{lead?.user_relead || '-'}</TableCell>
              <TableCell align="center">{lead?.relead_at || '-'}</TableCell>
              <TableCell align="center">{lead?.created_at}</TableCell>
              <TableCell align="center">
                {!lead.released && (
                  <Tooltip title="Indicar Lead manualmente" placement="top">
                    <span>
                      <IconButton
                        style={{ padding: 0, margin: 0 }}
                        onClick={() => handleIndicateLead(lead?.id, lead?.proposal)}>
                        <Icon path={mdiClipboardArrowLeftOutline} size={1} />
                      </IconButton>
                    </span>
                  </Tooltip>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DuplicatedLeadsTable;
